import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';

import HeaderMonarch from './HeaderMonarch';
import useHeaderMonarch from './logic/useHeaderMonarch';

import { getMessengerState } from 'redux/Messenger';

import {
  getActiveSpace,
  getActiveDesign,
  getLayoutModalActive,
  getAllOfUsersSpacesFrom,
  setLayoutModalActive
} from 'redux/Studio';
import { getUserId, isAdminUser, userIsProspect } from 'redux/User';

import { getShoppingCart } from 'shared/components/Checkout/state';
import { MONARCH_HEADER_ID } from 'shared/components/NavigationBar';
import { register } from 'shared/components/Registry';

import { FEATURE_FLAGS, getFeatureFlagEnabledBool } from 'shared/reducers/featureFlag';

import useZendeskHelpButton from './useZendeskHelpButton';

import PortaledZendeskButton from './PortaledZendeskButton';

export function HeaderMonarchController ({
  // current active space
  activeSpace = {},

  // all spaces for the current logged in user
  allSpaces = [],

  // all conversations for the current logged in user
  allConversations = {},

  // number of items currently in cart
  cartItemCount = 0,

  // To extend styling.
  className = '',

  // current design
  design = {},

  // routing history object
  history = {},

  // whether or not current user is an Admin
  isAdmin = false,

  // to distinguish studios from non studios
  isCurrentStudioReady = false,

  // used to identify second step of LV in re-skinned studio
  layoutModalActive = false,

  // the global redux dispatcher
  reduxDispatcher = () => {},

  // this is used to clear the selected layout in re-skinned studio
  dispatchSetLayoutModalActive = () => {},

  // id from last selected space
  spaceId = null,

  // current active studio
  studio = {},

  // used to position the drawer menu under the optional top banners
  topDrawerPosition = '3rem',

  // current user id
  userId = null,

  // feature flags
  feShopRewriteWebPPEnabled = false,
  feZendeskChatbot = false,
  showHelpMenu = false,

  // whether or not the logged in user is a prospect,
  // i.e., has not yet purchased a design package
  isProspect = false
} = {}) {
  const {
    ref: zendeskButtonRef,
    rightPos: zendeskButtonRight,
    onClick: zendeskHelpButtonClick,
    zendeskOpen
  } = useZendeskHelpButton();

  const {
    backButtonConfig,
    modsyButtonConfig,
    dispatch,
    handleCartClick,
    handleHelpClick,
    helpModalOpen,
    isLoggedOutSharedMode,
    projects
  } = useHeaderMonarch({
    activeSpace,
    allConversations,
    allSpaces,
    design,
    dispatchSetLayoutModalActive,
    feShopRewriteWebPPEnabled,
    feZendeskChatbot,
    history,
    isAdmin,
    isCurrentStudioReady,
    layoutModalActive,
    isProspect,
    openZendesk: zendeskHelpButtonClick,
    reduxDispatcher,
    spaceId,
    studio,
    userId
  });

  return (
    <Fragment>
      <HeaderMonarch
        backButton={backButtonConfig}
        modsyButtonConfig={modsyButtonConfig}
        cartItemCount={cartItemCount}
        className={className}
        dispatch={dispatch}
        headerID={MONARCH_HEADER_ID}
        helpModalOpen={helpModalOpen}
        isLoggedOutSharedMode={isLoggedOutSharedMode}
        onCartClick={handleCartClick}
        onHelpClick={handleHelpClick}
        projects={projects}
        showHelpMenu={showHelpMenu}
        topDrawerPosition={topDrawerPosition}
      />
      <PortaledZendeskButton
        onClick={zendeskHelpButtonClick}
        ref={zendeskButtonRef}
        rightPos={zendeskButtonRight}
        zendeskOpen={zendeskOpen}
      />
    </Fragment>
  );
}

const mapStateToProps = (state, ownProps) => {
  const activeSpace = getActiveSpace({ state });
  const cart = getShoppingCart(state);

  const isAdmin = isAdminUser(state);
  const spaceId = (activeSpace && activeSpace.id()) || null;

  // For debugging purposes, an admin user may want to inspect projects of another user.
  const userId = (isAdmin && activeSpace) ? activeSpace.userId() : getUserId(state);

  const showHelpMenu = getFeatureFlagEnabledBool(FEATURE_FLAGS.ShowHelpMenu, state);
  const isProspect = userIsProspect(state);
  const feShopRewriteWebPPEnabled = getFeatureFlagEnabledBool('fe_shop_rewrite_webpp', state);
  const feZendeskChatbot = getFeatureFlagEnabledBool(FEATURE_FLAGS.ZendeskChatbot, state);

  const messengerState = getMessengerState(state);

  return {
    activeSpace,
    allConversations: messengerState.messages,
    allSpaces: ownProps.ppoSpaces || getAllOfUsersSpacesFrom({ state, userId }),
    cartItemCount: cart.totalItemCount(),
    design: getActiveDesign({ state }),
    feShopRewriteWebPPEnabled,
    feZendeskChatbot,
    isAdmin,
    isProspect,
    layoutModalActive: getLayoutModalActive(state),
    showHelpMenu,
    spaceId,
    studio: activeSpace,
    userId
  };
};

const mapDispatchToProps = (reduxDispatcher) => ({
  reduxDispatcher,
  dispatchSetLayoutModalActive: (active) => {
    return reduxDispatcher(setLayoutModalActive(active));
  }
});

const withConnect = connect(mapStateToProps, mapDispatchToProps);
const withRegistry = register(MONARCH_HEADER_ID);

export default compose(withRouter, withRegistry, withConnect)(HeaderMonarchController);
